module.exports = __webpack_public_path__ + "img/bg3.7aca9045.png";